export default "__VITE_ASSET__BLEL92bW__"